<template>
  <div class="card">
    <div class="card-header">
      <h3>Số liệu đăng ký dòng họ</h3>
    </div>
    <div class="dang-ky">
      <b-row>
        <b-col lg="3">
          <a :href="linkDaDuyet" target="_blank">
            <div class="dang-ky__ok">
              <h5>Đã duyệt</h5>
              <div class="dang-ky__content">{{ da_duyet }}</div>
            </div>
          </a>
        </b-col>

        <b-col lg="3">
          <a :href="linkDangXuLy" target="_blank">
            <div class="dang-ky__inprocess">
              <h5>Đang xử lý</h5>
              <div class="dang-ky__content">{{ dang_xu_ly }}</div>
            </div>
          </a>
        </b-col>

        <b-col lg="3">
          <a :href="linkChoDuyet" target="_blank">
            <div class="dang-ky__await">
              <h5>Chờ duyệt</h5>
              <div class="dang-ky__content">{{ cho_duyet }}</div>
            </div>
          </a>
        </b-col>

        <b-col lg="3">
          <a :href="linkTuChoi" target="_blank">
            <div class="dang-ky__cancel">
              <h5>Từ chối</h5>
              <div class="dang-ky__content">{{ tu_choi }}</div>
            </div>
          </a>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import mushroom from "viettoc-api";
export default {
  data() {
    return {
      da_duyet: 0,
      cho_duyet: 0,
      tu_choi: 0,
      dang_xu_ly: 0,
      linkChoDuyet: "",
    };
  },
  methods: {
    fn_getLink() {
      this.linkChoDuyet =
        location.origin +
        "/admin/dang-ky-dong-ho/danh-sach-dang-ky-dong-ho?&filters=trang_thai%3Ddang_cho";
      this.linkDangXuLy =
        location.origin +
        "/admin/dang-ky-dong-ho/danh-sach-dang-ky-dong-ho?&filters=trang_thai%3Ddang_xu_ly";
      this.linkDaDuyet =
        location.origin +
        "/admin/dang-ky-dong-ho/danh-sach-dang-ky-dong-ho?&filters=trang_thai%3Dda_duyet";
      this.linkTuChoi =
        location.origin +
        "/admin/dang-ky-dong-ho/danh-sach-dang-ky-dong-ho?&filters=trang_thai%3Dtu_choi";
    },
    async fn_thongKe() {
      try {
        const response_da_duyet = await mushroom.dang_ky.listAsync(
          {
            fields:
              "id,ten_dong_ho,quoc_gia_id,tinh_id,huyen_id,xa_id,dia_chi,khoang_dinh,xung_ho,ho_ten,trong_ho,dien_thoai,email,trang_thai,li_do_tu_choi,thoi_diem_tao,thoi_diem_cap_nhat,dong_ho_id,thoi_diem_xet_duyet,nguoi_xet_duyet",
            filters: ["trang_thai=da_duyet"],
            limit: 1,
          },
          { cacheAge: 1 }
        );
        this.da_duyet = response_da_duyet.meta.total;
        console.log("Dòng họ đã duyệt", response_da_duyet);

        const response_dang_xu_ly = await mushroom.dang_ky.listAsync(
          {
            fields:
              "id,ten_dong_ho,quoc_gia_id,tinh_id,huyen_id,xa_id,dia_chi,khoang_dinh,xung_ho,ho_ten,trong_ho,dien_thoai,email,trang_thai,li_do_tu_choi,thoi_diem_tao,thoi_diem_cap_nhat,dong_ho_id,thoi_diem_xet_duyet,nguoi_xet_duyet",
            filters: ["trang_thai=dang_xu_ly"],
            limit: 1,
          },
          { cacheAge: 1 }
        );
        this.dang_xu_ly = response_dang_xu_ly.meta.total;
        console.log("Dòng họ đang xử lý", response_dang_xu_ly);

        const response_cho_duyet = await mushroom.dang_ky.listAsync(
          {
            fields:
              "id,ten_dong_ho,quoc_gia_id,tinh_id,huyen_id,xa_id,dia_chi,khoang_dinh,xung_ho,ho_ten,trong_ho,dien_thoai,email,trang_thai,li_do_tu_choi,thoi_diem_tao,thoi_diem_cap_nhat,dong_ho_id,thoi_diem_xet_duyet,nguoi_xet_duyet",
            filters: ["trang_thai=dang_cho"],
            limit: 1,
          },
          { cacheAge: 1 }
        );
        this.cho_duyet = response_cho_duyet.meta.total;
        console.log("Dòng họ chờ duyệt", response_cho_duyet);

        const response_tu_choi = await mushroom.dang_ky.listAsync({
          fields:
            "id,ten_dong_ho,quoc_gia_id,tinh_id,huyen_id,xa_id,dia_chi,khoang_dinh,xung_ho,ho_ten,trong_ho,dien_thoai,email,trang_thai,li_do_tu_choi,thoi_diem_tao,thoi_diem_cap_nhat,dong_ho_id,thoi_diem_xet_duyet,nguoi_xet_duyet",
          filters: ["trang_thai=tu_choi"],
          limit: 1,
        });
        this.tu_choi = response_tu_choi.meta.total;
        console.log("Dòng họ từ chối", response_tu_choi);
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
  },
  async created() {
    this.fn_getLink();
    await this.fn_thongKe();
  },
};
</script>

<style lang="scss">
a {
  text-decoration: none;
}
.box-style {
  border-radius: 10px;
  color: #fff;
}
.dang-ky {
  a {
    text-decoration: none;
  }
  padding: 20px;
  h5 {
    padding: 10px;
    border-bottom: 1px solid #ffffff;
    text-align: center;
  }
  &__ok,
  &__await,
  &__cancel {
    margin: 5px 0;
    @extend .box-style;
  }
  &__content {
    padding: 15px;
    font-size: 40px;
    font-weight: 600;
    text-align: center;
  }
  &__ok {
    background: #67c23a;
  }
  &__await {
    background: #e6a23c;
  }
  &__cancel {
    background: #f56c6c;
  }
}
@media (min-width: 992px) {
  .dang-ky__ok,
  .dang-ky__await,
  .dang-ky__cancel {
    margin: unset;
  }
}
</style>
